/* eslint arrow-body-style: 0 */
import { frontendURL } from '../../../helper/URLHelper';
import store from '../../../store/index';
import { subscriptionGuard } from '../../../helper/subscriptionHelper';
const ConversationView = () => import('./ConversationView.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/dashboard'),
      name: 'home',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: ConversationView,
      props: () => {
        return { inboxId: 0 };
      },
      beforeEnter: async (to, from, next) => {
        await subscriptionGuard(to, from, next, store);
      },
    },
    {
      path: frontendURL('accounts/:accountId/conversations/:conversation_id'),
      name: 'inbox_conversation',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: ConversationView,
      props: route => {
        return { inboxId: 0, conversationId: route.params.conversation_id };
      },
    },
    {
      path: frontendURL('accounts/:accountId/inbox/:inbox_id'),
      name: 'inbox_dashboard',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: ConversationView,
      props: route => {
        return { inboxId: route.params.inbox_id };
      },
    },
    {
      path: frontendURL(
        'accounts/:accountId/inbox/:inbox_id/conversations/:conversation_id'
      ),
      name: 'conversation_through_inbox',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: ConversationView,
      props: route => {
        return {
          conversationId: route.params.conversation_id,
          inboxId: route.params.inbox_id,
        };
      },
    },
    {
      path: frontendURL('accounts/:accountId/label/:label'),
      name: 'label_conversations',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: ConversationView,
      props: route => ({ label: route.params.label }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/label/:label/conversations/:conversation_id'
      ),
      name: 'conversations_through_label',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: ConversationView,
      props: route => ({
        conversationId: route.params.conversation_id,
        label: route.params.label,
      }),
    },
    {
      path: frontendURL('accounts/:accountId/team/:teamId'),
      name: 'team_conversations',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: ConversationView,
      props: route => ({ teamId: route.params.teamId }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/team/:teamId/conversations/:conversationId'
      ),
      name: 'conversations_through_team',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: ConversationView,
      props: route => ({
        conversationId: route.params.conversationId,
        teamId: route.params.teamId,
      }),
    },
    {
      path: frontendURL('accounts/:accountId/custom_view/:id'),
      name: 'folder_conversations',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: ConversationView,
      props: route => ({ foldersId: route.params.id }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/custom_view/:id/conversations/:conversation_id'
      ),
      name: 'conversations_through_folders',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: ConversationView,
      props: route => ({
        conversationId: route.params.conversation_id,
        foldersId: route.params.id,
      }),
    },
    {
      path: frontendURL('accounts/:accountId/mentions/conversations'),
      name: 'conversation_mentions',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: ConversationView,
      props: () => ({ conversationType: 'mention' }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/mentions/conversations/:conversationId'
      ),
      name: 'conversation_through_mentions',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: ConversationView,
      props: route => ({
        conversationId: route.params.conversationId,
        conversationType: 'mention',
      }),
    },
    {
      path: frontendURL('accounts/:accountId/unread/conversations'),
      name: 'conversation_unread',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: ConversationView,
      props: () => ({ conversationType: 'unread' }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/unread/conversations/:conversationId'
      ),
      name: 'conversation_through_unread',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: ConversationView,
      props: route => ({
        conversationId: route.params.conversationId,
        conversationType: 'unread',
      }),
    },
    {
      path: frontendURL('accounts/:accountId/participating/conversations'),
      name: 'conversation_participating',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: ConversationView,
      props: () => ({ conversationType: 'participating' }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/participating/conversations/:conversationId'
      ),
      name: 'conversation_through_participating',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: ConversationView,
      props: route => ({
        conversationId: route.params.conversationId,
        conversationType: 'participating',
      }),
    },
    {
      path: frontendURL('accounts/:accountId/agent-handled/conversations'),
      name: 'conversation_agent_handled',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: ConversationView,
      props: () => ({ agentActivity: true }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/agent-handled/conversations/:conversationId'
      ),
      name: 'conversation_through_agent_handled',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: ConversationView,
      props: route => ({
        conversationId: route.params.conversationId,
        agentActivity: true,
      }),
    },
    {
      path: frontendURL('accounts/:accountId/not-handled/conversations'),
      name: 'conversation_not_handled',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: ConversationView,
      props: () => ({ agentActivity: false }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/not-handled/conversations/:conversationId'
      ),
      name: 'conversation_through_not_handled',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: ConversationView,
      props: route => ({
        conversationId: route.params.conversationId,
        agentActivity: false,
      }),
    },
    {
      path: frontendURL('accounts/:accountId/scheduled_messages'),
      name: 'scheduled_messages',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: () => import('./ScheduledMessages.vue'),
    },
  ],
};
